import { render, staticRenderFns } from "./ProfileItem.vue?vue&type=template&id=b5c2d3cc&scoped=true&"
import script from "./ProfileItem.vue?vue&type=script&lang=js&"
export * from "./ProfileItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfileItem.vue?vue&type=style&index=0&id=b5c2d3cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c2d3cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5c2d3cc')) {
      api.createRecord('b5c2d3cc', component.options)
    } else {
      api.reload('b5c2d3cc', component.options)
    }
    module.hot.accept("./ProfileItem.vue?vue&type=template&id=b5c2d3cc&scoped=true&", function () {
      api.rerender('b5c2d3cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/list/components/ProfileItem.vue"
export default component.exports